import { NavLink } from "@mantine/core";
import { Tooltip } from "@onengine/component-library";
import { Link } from "@tanstack/react-router";
import SidebarIndicatorBadge from "../SidebarIndicatorBadge/SidebarIndicatorBadge";

type SidebarItemProps = {
  to: string;
  label: string;
  icon: React.ReactNode;
  opened: boolean;
  active?: boolean;
  exact?: boolean;
  right?: React.ReactNode;
  badgeCount?: number;
  onNavigate?: () => void;
};

export default function SidebarItem({
  to,
  label,
  icon,
  opened,
  active,
  exact,
  right,
  badgeCount,
  onNavigate,
}: SidebarItemProps) {
  const activeOptions = exact ? { exact: true } : undefined;

  const NavLinkIconButton = (
    <NavLink
      component={Link}
      to={to}
      activeOptions={activeOptions}
      active={active}
      // SERV-2710: the collapsed item hides its label, so the link needs a name of its own.
      aria-label={label}
      leftSection={icon}
      color={"var(--bg-neutral-bold-strong)"}
      styles={{
        root: {
          borderRadius: 8,
          justifyContent: "center",
          alignItems: "center",
          width: 40,
          height: 40,
        },
        section: { marginRight: 0 },
        label: { display: "none" },
      }}
    />
  );

  return opened ? (
    <NavLink
      component={Link}
      to={to}
      activeOptions={activeOptions}
      label={label}
      leftSection={icon}
      rightSection={right}
      active={active}
      onClick={onNavigate}
      px="sm"
      mih={{ base: 44, sm: 0 }}
      color={"var(--bg-neutral-bold-strong)"}
      styles={{
        root: { borderRadius: 8 },
        label: { whiteSpace: "nowrap" },
      }}
    />
  ) : typeof badgeCount === "number" && badgeCount > 0 ? (
    <SidebarIndicatorBadge badgeCount={badgeCount} position="top-end">
      <Tooltip content={label} pointer="center-right">
        {NavLinkIconButton}
      </Tooltip>
    </SidebarIndicatorBadge>
  ) : (
    <Tooltip content={label} pointer="center-right">
      {NavLinkIconButton}
    </Tooltip>
  );
}
